import {PermissionUtil} from "../utils/permission.util";
import {ApiModules, ApiOperations} from "@qid/core";

export const MasterPermissionList = [

  {
    module: 'Share',
    permissions: [
      {
        name: 'Can View All Shares',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'Organisations',
    permissions: [
      {
        name: 'Can View All Organisations',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.readAll)
      },
      {
        name: 'Can See Organisation Profile',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.read)
      },
      {
        name: 'Can Delete Organisations',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.delete)
      }
    ]
  },

  {
    module: 'Plan Purchase',
    permissions: [
      {
        name: 'Can View All Purchases',
        permission: PermissionUtil.PermissionName(ApiModules.PlanPurchase, ApiOperations.readAll)
      },
      {
        name: 'Can Activate Plan',
        permission: PermissionUtil.PermissionName(ApiModules.PlanPurchase, ApiOperations.create)
      }
    ]
  },
  {
    module: 'Order',
    permissions: [
      {
        name: 'Can View All Orders',
        permission: PermissionUtil.PermissionName(ApiModules.Order, ApiOperations.readAll)
      },
      {
        name: 'Can Create Order',
        permission: PermissionUtil.PermissionName(ApiModules.Order, ApiOperations.create)
      },
      {
        name: 'Can Update Order',
        permission: PermissionUtil.PermissionName(ApiModules.Order, ApiOperations.update)
      },
      {
        name: 'Can Delete Order',
        permission: PermissionUtil.PermissionName(ApiModules.Order, ApiOperations.delete)
      }
    ]
  },
  {
    module: 'Payment',
    permissions: [
      {
        name: 'Can View All Payments',
        permission: PermissionUtil.PermissionName(ApiModules.Payment, ApiOperations.readAll)
      },
      {
        name: 'Can Create Payment',
        permission: PermissionUtil.PermissionName(ApiModules.Payment, ApiOperations.create)
      },
      {
        name: 'Can Update Payment',
        permission: PermissionUtil.PermissionName(ApiModules.Payment, ApiOperations.update)
      },
      {
        name: 'Can Delete Payment',
        permission: PermissionUtil.PermissionName(ApiModules.Payment, ApiOperations.delete)
      }
    ]
  },
  {
    module: 'Features',
    permissions: [
      {
        name: 'Can View All Features',
        permission: PermissionUtil.PermissionName(ApiModules.Feature, ApiOperations.readAll)
      },
      {
        name: 'Can View All Feature Groups',
        permission: PermissionUtil.PermissionName(ApiModules.FeatureGroup, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'Scanner',
    permissions: [
      {
        name: 'Can View All Scanners',
        permission: PermissionUtil.PermissionName(ApiModules.Scanner, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'Configurations',
    permissions: [
      {
        name: 'Master Configuration',
        permission: PermissionUtil.PermissionName(ApiModules.MasterConfigurations, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'VMS',
    permissions: [
      {
        name: 'Can View VMS',
        permission: PermissionUtil.PermissionName(ApiModules.VMS, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'Users',
    permissions: [
      {
        name: 'Can View All Users',
        permission: PermissionUtil.PermissionName(ApiModules.User, ApiOperations.readAll)
      },
      {
        name: 'Can View Detailed User Profile',
        permission: PermissionUtil.PermissionName(ApiModules.User, ApiOperations.read)
      },
      {
        name: 'Can Delete an Users',
        permission: PermissionUtil.PermissionName(ApiModules.User, ApiOperations.delete)

      }
    ]
  }, {
    module: 'SID',
    permissions: [
      {
        name: 'Can View All SIDs',
        permission: PermissionUtil.PermissionName(ApiModules.SID, ApiOperations.readAll)

      },
      {
        name: 'Can Update SID',
        permission: PermissionUtil.PermissionName(ApiModules.SID, ApiOperations.update)
      },
      {
        name: 'Can Delete SID',
        permission: PermissionUtil.PermissionName(ApiModules.SID, ApiOperations.delete)
      }
    ]
  },
  {
    module: 'Master User',
    permissions: [
      {
        name: 'Can View All Master Users',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.readAll)
      },
      {
        name: 'Can Create Master User',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.create)
      },
      {
        name: 'Can Update Master User',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.update)
      },
      {
        name: 'Can Delete Master User',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.delete)
      }
    ]
  }

]
